<svelte:options accessors={true}/>

<style>
  .Arrow {
    display:block; position:absolute; overflow:visible;
    margin:0px; padding:0px; border:none; border-radius:0px;
  }
</style>

<script context="module" lang="ts">
  import { onMount } from 'svelte'
</script>

<script lang="ts">
  let this_element
  let element_width = 10, element_height = 10, element_viewbox = '0 0 10 10'
  let arrow_line, arrow_head

  function create_arrow () {
    element_viewbox = "0 0 " + element_width + " " + element_height
    arrow_line = `0,${element_height-10} ${element_width-6},${element_height-10} ${element_width-6},0`
    arrow_head = `${element_width-10},4 ${element_width-6},0 ${element_width-2},4`
  }
  onMount(create_arrow)

  $: if (this_element != null) { create_arrow() }
</script>

<div {...$$restProps} class:Arrow={true} bind:this={this_element}
  bind:clientWidth={element_width} bind:clientHeight={element_height}>
  <svg xmlns="http://www.w3.org/2000/svg"
    width={element_width} height={element_height} viewBox={element_viewbox}
  >
    <polyline points="{arrow_line}" stroke="black" fill="none"/>
    <polyline points="{arrow_head}" fill="black"/>
  </svg>
</div>
